import { render, staticRenderFns } from "./commonConfig.vue?vue&type=template&id=d8c91a80&scoped=true"
import script from "./commonConfig.vue?vue&type=script&lang=js"
export * from "./commonConfig.vue?vue&type=script&lang=js"
import style0 from "./commonConfig.vue?vue&type=style&index=0&id=d8c91a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c91a80",
  null
  
)

export default component.exports